
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#ff8f00","d":"M8 37L23.234 8.436a.84.84 0 011.494.02L30 19 8 37z"}}),_c('path',{attrs:{"fill":"#ffa000","d":"M8 36.992l5.546-34.199c.145-.895 1.347-1.089 1.767-.285L26 22.992l-18 14z"}}),_c('path',{attrs:{"fill":"#ff6f00","d":"M8.008 36.986l.2-.157 17.529-14.341-4.944-9.476z"}}),_c('path',{attrs:{"fill":"#ffc400","d":"M8 37l26.666-25.713a.954.954 0 011.606.547L40 37l-15 8.743a2.002 2.002 0 01-1.961 0L8 37z"}})])
          )
        }
      }
    